export enum LookerReportEnum {
  Content = 'content',
  User = 'user',
  Portfolio = 'portfolio',
  Reservation = 'reservation',
  UserSearch = 'user_search',
  PostAnalytics = 'post_analytics',
  CompanyAnalytics = 'company_analytics',
  WorkOrdersAnalytics = 'work_orders_analytics',
  WorkOrdersServiceRequestsReporting = 'work_orders_service_requests_reporting',
  WorkOrdersTargetTimesReport = 'work_orders_target_times_report',
  WorkOrdersPreventativeMaintenanceTasksReporting = 'work_orders_preventative_maintenance_tasks_reporting',
  WorkOrdersServiceRequestResponseTimeAll = 'work_orders_service_request_response_time_all',
  WorkOrdersServiceRequestResponseTimeAverage = 'work_orders_service_request_response_time_average',
  WorkOrdersServiceRequestCompletionTimeAll = 'work_orders_service_request_completion_time_all',
  WorkOrdersServiceRequestCompletionTimeAverage = 'work_orders_service_request_completion_time_average',
  WorkOrdersServiceRequestAcceptanceTimeAll = 'work_orders_service_request_acceptance_time_all',
  WorkOrdersServiceRequestAcceptanceTimeAverage = 'work_orders_service_request_acceptance_time_average',
  WorkOrdersServiceRequestTenantSurveySummaryAll = 'work_orders_service_request_tenant_survey_summary_all',
  WorkOrdersServiceRequestTenantSurveySummaryDetails = 'work_orders_service_request_tenant_survey_summary_details',
  WorkOrdersPreventativeMaintenanceTimeEvaluationByTask = 'work_orders_preventative_maintenance_time_evaluation_by_task',
  WorkOrdersPreventativeMaintenanceTaskPerformanceByProperty = 'work_orders_preventative_maintenance_task_performance_by_property',
  WorkOrdersPreventativeMaintenanceTaskPerformanceByAssignedUser = 'work_orders_preventative_maintenance_task_performance_by_assigned_user',
  WorkOrdersPreventativeMaintenanceTaskPerformanceByAssignedTeam = 'work_orders_preventative_maintenance_task_performance_by_assigned_team',
  WorkOrdersPreventativeMaintenanceTaskPerformanceBySchedule = 'work_orders_preventative_maintenance_task_performance_by_schedule',
  UserEngagementAnalytics = 'user_engagement_analytics',
  AdminDashboardAnalytics = 'admin_dashboard_analytics',
  TenantSentimentAnalytics = 'tenant_sentiment_analytics',
  AccessAnalytics = 'access_analytics',
  EventAnalytics = 'event_analytics',
  VisitorManagementAnalytics = 'visitor_management_analytics',
  WorkOrdersBillingExportReport = 'work_orders_billing_export_report',
  WorkOrdersFinCharge = 'work_orders_fin_charge',
  WorkOrdersFinJournal = 'work_orders_fin_journal',
}

// Note: it is better to keep these values hardcoded rather then move to SSM Shared Config due to simplicity of local debugging
export const reportUrlMappingForVtsAccountDev = {
  [LookerReportEnum.Content]: '/embed/dashboards/2606',
  [LookerReportEnum.User]: '/embed/dashboards/2601',
  [LookerReportEnum.Portfolio]: '/embed/dashboards/2605',
  [LookerReportEnum.Reservation]: '/embed/dashboards/2602',
  [LookerReportEnum.UserSearch]: '/embed/dashboards/2610',
  [LookerReportEnum.PostAnalytics]: '/embed/dashboards/2603',
  [LookerReportEnum.CompanyAnalytics]: '/embed/dashboards/2604',
  [LookerReportEnum.WorkOrdersAnalytics]: '/embed/dashboards/2611',
  [LookerReportEnum.UserEngagementAnalytics]: '/embed/dashboards/2608',
  [LookerReportEnum.AdminDashboardAnalytics]: '/embed/dashboards/2609',
  [LookerReportEnum.TenantSentimentAnalytics]: '/embed/dashboards/2607',
  [LookerReportEnum.AccessAnalytics]: '/embed/dashboards/2644',
  [LookerReportEnum.EventAnalytics]: '/embed/dashboards/2674',
  [LookerReportEnum.VisitorManagementAnalytics]: '/embed/dashboards/2877',
  [LookerReportEnum.WorkOrdersServiceRequestsReporting]:
    '/embed/dashboards/3090',
  [LookerReportEnum.WorkOrdersTargetTimesReport]:
    '/embed/dashboards/3264',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTasksReporting]:
    '/embed/dashboards/3094',
  [LookerReportEnum.WorkOrdersServiceRequestResponseTimeAll]:
    '/embed/dashboards/3108',
  [LookerReportEnum.WorkOrdersServiceRequestResponseTimeAverage]:
    '/embed/dashboards/3109',
  [LookerReportEnum.WorkOrdersServiceRequestCompletionTimeAll]:
    '/embed/dashboards/3106',
  [LookerReportEnum.WorkOrdersServiceRequestCompletionTimeAverage]:
    '/embed/dashboards/3107',
  [LookerReportEnum.WorkOrdersServiceRequestAcceptanceTimeAll]:
    '/embed/dashboards/3110',
  [LookerReportEnum.WorkOrdersServiceRequestAcceptanceTimeAverage]:
    '/embed/dashboards/3111',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTimeEvaluationByTask]:
    '/embed/dashboards/3112',
  [LookerReportEnum.WorkOrdersServiceRequestTenantSurveySummaryAll]:
    '/embed/dashboards/3153',
  [LookerReportEnum.WorkOrdersServiceRequestTenantSurveySummaryDetails]:
    '/embed/dashboards/3154',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTaskPerformanceByProperty]:
    '/embed/dashboards/3189',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTaskPerformanceByAssignedUser]:
    '/embed/dashboards/3191',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTaskPerformanceByAssignedTeam]:
    '/embed/dashboards/3195',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTaskPerformanceBySchedule]:
    '/embed/dashboards/3192',
  [LookerReportEnum.WorkOrdersBillingExportReport]: '/embed/dashboards/3276',
  [LookerReportEnum.WorkOrdersFinCharge]: '/embed/dashboards/3267',
  [LookerReportEnum.WorkOrdersFinJournal]: '/embed/dashboards/3269',
};

export const reportUrlMappingForVtsAccountProd = {
  [LookerReportEnum.Content]: '/embed/dashboards/2716',
  [LookerReportEnum.User]: '/embed/dashboards/2713',
  [LookerReportEnum.Portfolio]: '/embed/dashboards/2715',
  [LookerReportEnum.Reservation]: '/embed/dashboards/2712',
  [LookerReportEnum.UserSearch]: '/embed/dashboards/2720',
  [LookerReportEnum.PostAnalytics]: '/embed/dashboards/2711',
  [LookerReportEnum.CompanyAnalytics]: '/embed/dashboards/2714',
  [LookerReportEnum.WorkOrdersAnalytics]: '/embed/dashboards/2721',
  [LookerReportEnum.UserEngagementAnalytics]: '/embed/dashboards/2718',
  [LookerReportEnum.AdminDashboardAnalytics]: '/embed/dashboards/2719',
  [LookerReportEnum.TenantSentimentAnalytics]: '/embed/dashboards/2717',
  [LookerReportEnum.AccessAnalytics]: '/embed/dashboards/2734',
  [LookerReportEnum.EventAnalytics]: '/embed/dashboards/2787',
  [LookerReportEnum.VisitorManagementAnalytics]: '/embed/dashboards/2908',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTasksReporting]:
    '/embed/dashboards/3039',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTimeEvaluationByTask]:
    '/embed/dashboards/3040',
  [LookerReportEnum.WorkOrdersServiceRequestsReporting]:
    '/embed/dashboards/3047',
  [LookerReportEnum.WorkOrdersTargetTimesReport]:
    '/embed/dashboards/3150',
  [LookerReportEnum.WorkOrdersServiceRequestResponseTimeAll]:
    '/embed/dashboards/3043',
  [LookerReportEnum.WorkOrdersServiceRequestResponseTimeAverage]:
    '/embed/dashboards/3046',
  [LookerReportEnum.WorkOrdersServiceRequestCompletionTimeAll]:
    '/embed/dashboards/3041',
  [LookerReportEnum.WorkOrdersServiceRequestCompletionTimeAverage]:
    '/embed/dashboards/3045',
  [LookerReportEnum.WorkOrdersServiceRequestAcceptanceTimeAll]:
    '/embed/dashboards/3042',
  [LookerReportEnum.WorkOrdersServiceRequestAcceptanceTimeAverage]:
    '/embed/dashboards/3044',
  [LookerReportEnum.WorkOrdersServiceRequestTenantSurveySummaryAll]:
    '/embed/dashboards/3078',
  [LookerReportEnum.WorkOrdersServiceRequestTenantSurveySummaryDetails]:
    '/embed/dashboards/3077',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTaskPerformanceByProperty]:
    '/embed/dashboards/3098',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTaskPerformanceByAssignedUser]:
    '/embed/dashboards/3097',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTaskPerformanceByAssignedTeam]:
    '/embed/dashboards/3099',
  [LookerReportEnum.WorkOrdersPreventativeMaintenanceTaskPerformanceBySchedule]:
    '/embed/dashboards/3101',
  [LookerReportEnum.WorkOrdersBillingExportReport]: '/embed/dashboards/3154',
  [LookerReportEnum.WorkOrdersFinCharge]: '/embed/dashboards/3156',
  [LookerReportEnum.WorkOrdersFinJournal]: '/embed/dashboards/3155',
};

export const tenantReportUrlMappingForVtsAccountDev = {
  [LookerReportEnum.Content]: '/embed/dashboards/3006',
  [LookerReportEnum.PostAnalytics]: '/embed/dashboards/3007',
  [LookerReportEnum.WorkOrdersAnalytics]: '/embed/dashboards/3003',
  [LookerReportEnum.UserEngagementAnalytics]: '/embed/dashboards/2608',
  [LookerReportEnum.AdminDashboardAnalytics]: '/embed/dashboards/3005',
  [LookerReportEnum.AccessAnalytics]: '/embed/dashboards/3004',
  [LookerReportEnum.EventAnalytics]: '/embed/dashboards/2991',
  [LookerReportEnum.VisitorManagementAnalytics]: '/embed/dashboards/3008',
};

export const tenantReportUrlMappingForVtsAccountProd = {
  [LookerReportEnum.Content]: '/embed/dashboards/2981',
  [LookerReportEnum.PostAnalytics]: '/embed/dashboards/2984',
  [LookerReportEnum.WorkOrdersAnalytics]: '/embed/dashboards/2986',
  [LookerReportEnum.UserEngagementAnalytics]: '/embed/dashboards/2718',
  [LookerReportEnum.AdminDashboardAnalytics]: '/embed/dashboards/2980',
  [LookerReportEnum.AccessAnalytics]: '/embed/dashboards/2983',
  [LookerReportEnum.EventAnalytics]: '/embed/dashboards/2984',
  [LookerReportEnum.VisitorManagementAnalytics]: '/embed/dashboards/2985',
};
